import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { SHOP_PROMPT_SCHEDULES_API } from '../../constants/central-api';
import type { PromptSchedule } from './types';

export default async function get_prompt_schedules_api_call(): Promise<
  PromptSchedule[]
> {
  const shopSlug = store.getState().user?.company?.shop_slug;
  const accessToken = store.getState().auth.authorization.accessToken;

  if (!shopSlug) return [];

  const requestInfo: RequestInfo = {
    url: SHOP_PROMPT_SCHEDULES_API(shopSlug),
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: accessToken.type + ' ' + accessToken?.sellerToken,
    },
  };

  const res: any = await asyncHandler(
    requestInfo,
    'GET_PROMPT_SCHEDULES',
    'Prompt schedules loaded.',
    false
  );

  const response = res?.data;
  if (!response?.success) return [];
  const raw = response?.data;
  return Array.isArray(raw) ? raw : [];
}
